import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { RectangleFViewModel } from "./rectangle-f.view-model";

@Component({
  selector: "evrideo-graphics-rectangle-f",
  templateUrl: "./rectangle-f.component.html",
  styleUrls: ["./rectangle-f.component.scss"],
})
export class RectangleFComponent implements OnInit {
  @Input()
  vm: RectangleFViewModel;
  constructor() {}
  ngOnInit(): void {}


}
